
import Vue from "vue";
import auth from "../services/aws-exports";
import { AuthService } from "@/services/auth.service";
import { container } from "@/services/container";
import { useAuth } from "@/store/auth";
import { Hub } from "aws-amplify";
const authService: AuthService = container.get("authService");

export default Vue.extend({
  data: () => ({
    isLoggedIn: false,
    authCredentials: auth,
  }),
  mounted() {
    Hub.listen("auth", ({ payload: { event } }) => {
      if (event === "signIn") {
        this.setUserGroup();
        this.setAuthStatus();
        this.$router.push({ name: "Home" });
      }
    });
  },
  methods: {
    setUserGroup() {
      authService.getGroupsAsync().then((res) => {
        if (res.length) {
          useAuth().userGroup = res[0];
        }
      });
    },
    setAuthStatus() {
      useAuth().getCurrentUserInfo();
    },
  },
});
